import { dashboardGuard } from '../guards';

import settingsRoutes from './settings';
import showsRoutes from './shows';

import Dashboard from '@/views/Dashboard.vue';
import Home from '@/views/Dashboard/Home.vue';
import Integrations from '@/views/Dashboard/Integrations.vue';

export default [
    {
        path: '/',
        component: Dashboard,
        meta: {
            requiresAuth: true,
        },
        children: [
            {
                path: '',
                component: Home,
                meta: {
                    title: 'Dashboard',
                },
            },
            {
                path: 'platforms',
                component: Integrations,
                meta: {
                    title: 'Platforms',
                },
            },
            ...settingsRoutes,
            ...showsRoutes,
        ],
        beforeEnter: dashboardGuard,
    },
];
